(function($) {
	formHelper.addRule({
		form: '.form-search-transactions',
		xhrBeforeSend: function() {
			$(".form-search-transactions select").each(function() {
				if(this.value.indexOf("ImpersonateMyAccountUser") > -1) {
					window.open(this.value, '_blank');
					this.cancel();
				}
			});
		},
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);

jQuery(function initToolsSearchTransactions($) {
	$('.search-transactions-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-transactions');

		$('#search-transactions-order-edit').each(function() {
			// For the Order Edit form, we need the ability to modify arrival and departure dates
			var $arrivalDate = $('#arrivalDate').pickadate({
				max: 730,
				selectYears: 5,
				selectMonths: true,
				labelMonthSelect: 'Select Month',
				labelYearSelect: 'Select Year',
				format: 'mm/dd/yyyy',
				formatSubmit: 'mm/dd/yyyy'
			});
			var arrivalDatePicker = $arrivalDate.pickadate('picker');

			var $departureDate = $('#departureDate').pickadate({
				max: 730,
				selectYears: 5,
				selectMonths: true,
				labelMonthSelect: 'Select Month',
				labelYearSelect: 'Select Year',
				format: 'mm/dd/yyyy',
				formatSubmit: 'mm/dd/yyyy'
			});
			var departureDatePicker = $departureDate.pickadate('picker');

			// Check if there’s a “from” or “to” date to start with.
			if ( arrivalDatePicker.get('value') ) {
				departureDatePicker.set('min', arrivalDatePicker.get('select'));
			}
			
			if ( departureDatePicker.get('value') ) {
				arrivalDatePicker.set('max', departureDatePicker.get('select'));
			}

			// When something is selected, update the date range limits.
			$('#arrivalDate').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#departureDate').pickadate('picker').set('min', $('#arrivalDate').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#departureDate').pickadate('picker').set('min', false); }
			});

			$('#departureDate').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#arrivalDate').pickadate('picker').set('max', $('#departureDate').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#arrivalDate').pickadate('picker').set('max', false); }
			});
		});

		$('#form-search-transactions').each(function() {
			for(i=1; i<=4; i++) {
				// Date Range form elements
				// ------------------
				var $dateRangeStart = $('#date-range-start-' + i).pickadate({
					max: 730,
					selectYears: 5,
					selectMonths: true,
					labelMonthSelect: 'Select Month',
					labelYearSelect: 'Select Year',
					format: 'mm/dd/yyyy',
					formatSubmit: 'mm/dd/yyyy'
				});
				var dateRangeStartPicker = $dateRangeStart.pickadate('picker');

				var $dateRangeEnd = $('#date-range-end-' + i).pickadate({
					max: 730,
					selectYears: 5,
					selectMonths: true,
					labelMonthSelect: 'Select Month',
					labelYearSelect: 'Select Year',
					format: 'mm/dd/yyyy',
					formatSubmit: 'mm/dd/yyyy'
				});
				var dateRangeEndPicker = $dateRangeEnd.pickadate('picker');

				// Check if there’s a “from” or “to” date to start with.
				if ( dateRangeStartPicker.get('value') ) {
					dateRangeEndPicker.set('min', dateRangeStartPicker.get('select'));
				}
				
				if ( dateRangeEndPicker.get('value') ) {
					dateRangeStartPicker.set('max', dateRangeEndPicker.get('select'));
				}
			}

			// When something is selected, update the date range limits.
			$('#date-range-start-1').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-end-1').pickadate('picker').set('min', $('#date-range-start-1').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-end-1').pickadate('picker').set('min', false); }
			});

			$('#date-range-end-1').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-start-1').pickadate('picker').set('max', $('#date-range-end-1').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-start-1').pickadate('picker').set('max', false); }
			});


			$('#date-range-start-2').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-end-2').pickadate('picker').set('min', $('#date-range-start-2').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-end-2').pickadate('picker').set('min', false); }
			});

			$('#date-range-end-2').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-start-2').pickadate('picker').set('max', $('#date-range-end-2').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-start-2').pickadate('picker').set('max', false); }
			});


			$('#date-range-start-3').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-end-3').pickadate('picker').set('min', $('#date-range-start-3').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-end-3').pickadate('picker').set('min', false); }
			});

			$('#date-range-end-3').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-start-3').pickadate('picker').set('max', $('#date-range-end-3').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-start-3').pickadate('picker').set('max', false); }
			});


			$('#date-range-start-4').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-end-4').pickadate('picker').set('min', $('#date-range-start-4').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-end-4').pickadate('picker').set('min', false); }
			});

			$('#date-range-end-4').pickadate('picker').on('set', function(event) {
				if ( event.select ) { $('#date-range-start-4').pickadate('picker').set('max', $('#date-range-end-4').pickadate('picker').get('select')); }
				else if ( 'clear' in event ) { $('#date-range-start-4').pickadate('picker').set('max', false); }
			});
		});
	});
});

jQuery(function initToolsSearchTransactionsResults($) {
	$('.search-transactions-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-search-transactions-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});

		// Bulk Order Notes Functions
		$('.orderid-select').click(function(event) {  //on click
			if(this.checked) { // check select status
				$('.orderid-checkbox').each(function() { //loop through each checkbox
					this.checked = true;  //select all checkboxes with class "orderid-checkbox"               
				});
			}
			else {
				$('.orderid-checkbox').each(function() { //loop through each checkbox
					this.checked = false; //deselect all checkboxes with class "orderid-checkbox"                       
				});
			}
		});

		$('#click-here').click(function(event) {  //on click
		    var $orderidCheckedValues = '';

			$('.orderid-checkbox').each(function() { //loop through each checkbox
		        if(this.checked) { // check select status
		        	if($orderidCheckedValues !== '') { $orderidCheckedValues += ','; }
			        $orderidCheckedValues += this.value;
			    }      
		    });

		    if($orderidCheckedValues !== '') {		    	
		    	$('.order-notes-link').attr('href', '/tools/search-menu/search-transactions/details/notes?orderids=' + $orderidCheckedValues);
		    	$('.order-notes-apply').css('display','block');
		    }
		    else {
		    	$('.order-notes-apply').css('display','none');
		    }
		});
	});
});

jQuery(function($) {
	$('.js-search-type-actions').change(function() { 
		selectedValue = $(this).val();
		
		if(selectedValue !== '') {
			for(i=1; i<=4; i++) {
				//alert("Makes it here... " + i);
			
				if(selectedValue === 'fallout') {
					$("#search-type-" + i + " option[value='confirmationNumber']").remove();
				}
				else {
			        $('#search-type-' + i).append($("<option/>", {value: 'confirmationNumber', text: 'Confirmation Number'}));
				}			
			}

			sortSearchTypeList();
		}
	});

	$('.js-search-type-1-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 1) { $("#search-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	$('.js-search-type-2-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 2) { $("#search-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	$('.js-search-type-3-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 3) { $("#search-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	$('.js-search-type-4-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 4) { $("#search-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	function sortSearchTypeList() {
		// Sort all the Search Type lists
		var options1 = $('#search-type-1 option');
		var arr1 = options1.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr1.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options1.each(function(i, o) {
		  o.value = arr1[i].v;
		  $(o).text(arr1[i].t);
		});

		var options2 = $('#search-type-2 option');
		var arr2 = options2.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr2.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options2.each(function(i, o) {
		  o.value = arr2[i].v;
		  $(o).text(arr2[i].t);
		});

		var options3 = $('#search-type-3 option');
		var arr3 = options3.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr3.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options3.each(function(i, o) {
		  o.value = arr3[i].v;
		  $(o).text(arr3[i].t);
		});

		var options4 = $('#search-type-4 option');
		var arr4 = options4.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr4.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options4.each(function(i, o) {
		  o.value = arr4[i].v;
		  $(o).text(arr4[i].t);
		});
	}

	$('.js-date-range-type-1-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 1) { $("#date-range-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	$('.js-date-range-type-2-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 2) { $("#date-range-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	$('.js-date-range-type-2-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 2) { $("#date-range-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});

	$('.js-date-range-type-4-actions').change(function() { 
		selectedValue = $(this).val();
		for(i=1; i<=4; i++) { if(i !== 4) { $("#date-range-type-" + i + " option[value=" + selectedValue +"]").remove(); } }
		sortSearchTypeList();
	});


	function sortDateRangeList() {
		// Sort all the Search Type lists
		var options1 = $('#date-range-type-1 option');
		var arr1 = options1.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr1.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options1.each(function(i, o) {
		  o.value = arr1[i].v;
		  $(o).text(arr1[i].t);
		});

		var options2 = $('#date-range-type-2 option');
		var arr2 = options2.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr2.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options2.each(function(i, o) {
		  o.value = arr2[i].v;
		  $(o).text(arr2[i].t);
		});

		var options3 = $('#date-range-type-3 option');
		var arr3 = options3.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr3.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options3.each(function(i, o) {
		  o.value = arr3[i].v;
		  $(o).text(arr3[i].t);
		});

		var options4 = $('#date-range-type-4 option');
		var arr4 = options4.map(function(_, o) { return { t: $(o).text(), v: o.value }; }).get();
		arr4.sort(function(o1, o2) { return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0; });
		options4.each(function(i, o) {
		  o.value = arr4[i].v;
		  $(o).text(arr4[i].t);
		});
	}
});


jQuery(function($) {
	$('.js-search-transactions-actions').change(function() { 
		if($(this).val() !== '') {
			document.location.href = $(this).val(); 
		}
	})
});
